// Views
import Navbar from "./components/global/Navbar";
import Footer from "./components/global/Footer";
import Sidebar from "./components/global/Sidebar";
import svgtest from "./components/global/SVG.vue";
import Container from "./components/Container";
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import PasswordReset from "./components/auth/PasswordReset";
import PasswordUpdate from "./components/auth/PasswordUpdate";
import ProfileEdit from "./components/auth/ProfileEdit";
import updatereg from "./components/auth/UpdateRegistration";
import HabitsDash from "./components/habits/HabitsDash";
import HabitsSetup from "./components/habits/HabitsSetup";
import habittrackermodal from "./components/habits/modal/HabitTrackerModal";
import habitresultsmodal from "./components/habits/modal/HabitResultsModal";
import habitresults from "./components/habits/HabitResults";
import assetmgmt from "./components/edu/assetmanagement/AssetMgmt.vue";
import coursemanage from "./components/edu/modal/CourseManage.vue";
import lessonsmanage from "./components/edu/LessonsManage.vue";
import editlesson from "./components/edu/modal/EditLesson.vue";
import edudash from "./components/edu/EduDash.vue";
import lessoncatmanage from "./components/edu/modal/LessonCategory.vue";
//Learning:
import learningcentral from "./components/learning/LearningCentral.vue";
import lessonmodal from "./components/learning/modal/DisplayLesson.vue";
import FuturemeDash from "./components/fself/FutureMeDash";
import FuturemeSetup from "./components/fself/FutureMeSetup";
import FuturemeLifearea from "./components/fself/modal/FutureMeLifeArea";
import FuturemeTracker from "./components/fself/FutureMeTracker";
import FuturemeResults from "./components/fself/FutureMeResults";
import FuturemeResultsn from "./components/fself/FutureMeResultsNew.vue";
import lettersdash from "./components/comms/LettersDash";
import lettersdashp from "./components/comms/LettersDashParent";
import futureselfletter from "./components/comms/modal/FutureSelfLetter";
import testpopupmodal from "./components/test/TestPopupModal.vue";
import userprefs from "./components/user/UserPrefs.vue";
import uservideos from "./components/user/UserVideoSetup.vue";
import uservideodisplay from "./components/user/UserVideoDisplay.vue";
import movementmgmt from "./components/workout/Admin/ManageMovement.vue";
import myworkout from "./components/workout/MyWorkouts.vue";
import fbworkout from "./components/workout/FlexBoxWorkouts.vue";
import videodisplaymodal from "./components/workout/modal/VideoDisplayModal.vue";
import genericvideodisplaymodal from "./components/global/popup/VideoDisplayModal.vue";
import genericpagedisplaymodal from "./components/global/popup/GenericPageDisplayModal.vue";
import videolibrary from "./components/workout/VideoLibrary.vue";
import ForumHome from "./components/forum/ForumHome.vue";
import showofforumdash from "./components/forum/ShowofforumHome.vue";
import showofforumcommunity from "./components/forum/ShowofforumCommunity.vue";
import showofforumcreate from "./components/forum/ShowofforumCreate.vue";
import showofforumcreatem from "./components/forum/ShowofforumCreate_w_minify.vue";
import tsdetailmodal from "./components/forum/modal/TSDetailModal.vue";//time-slice
import tsvisibilityswitchermodal from "./components/forum/modal/UpdateVisibilityModal.vue";//time-slice
import prizes from "./components/rewards/Rewards.vue";
import sitedash from "./components/rewards/SiteDash.vue";
import testcanvas from "./components/test/canvas.vue";
import svgbase from "./components/rewards/svg/SVGBase.vue";
import newstarterchecklist from "./components/user/NewStarterChecklist.vue";
import morningeveningfocus from "./components/user/MorningEveningFocus.vue";
import actionhabitsdash from "./components/action_habits/ActionHabitsDash.vue"
import actionhabitssetup from "./components/action_habits/ActionHabitsSetup";
import actionhabittrackermodal from "./components/action_habits/modal/TrackActionHabitModal";
import actionhabitresultsmodal from "./components/action_habits/modal/ActionHabitResultsModal";

import kssabotagedash from "./components/kill_self_sabotage/KillSelfSabotageDash.vue"
import kssabotagesetup from "./components/kill_self_sabotage/KillSelfSabotageSetup";
import kssabotagetrackermodal from "./components/kill_self_sabotage/modal/KillSelfSabotageTrackker";
import kssabotageresultsmodal from "./components/kill_self_sabotage/modal/KillSelfSabotageResultsModal";
import celebration from "./components/rewards/Celebration.vue";
import tscameracapture from "./components/timeslice/CameraCapture.vue";
import tsphotopreview from "./components/timeslice/PhotoPreview.vue";
import tstimersettings from "./components/timeslice/TimerSettings.vue";
import leaderboard from "./components/rewards/LeaderBoard.vue";


require("./bootstrap");

window.Vue = require("vue").default;

const app = new Vue({
    el: "#app",
    components: {


        Container,
        Navbar,
        Sidebar,
        Footer,
        Login,
        Register,
        PasswordReset,
        PasswordUpdate,
        ProfileEdit,
        updatereg,
        HabitsDash,
        HabitsSetup,
        habittrackermodal,
        habitresultsmodal,
        habitresults,

        actionhabitsdash,
        actionhabitssetup,
        actionhabittrackermodal,
        actionhabitresultsmodal,
        kssabotagedash,
        kssabotagesetup,
        kssabotagetrackermodal,
        kssabotageresultsmodal,

        FuturemeSetup,
        FuturemeDash,
        FuturemeLifearea,
        FuturemeTracker,
        FuturemeResults,
        FuturemeResultsn,
        testpopupmodal,
        userprefs,
        uservideos,
        uservideodisplay,
        movementmgmt,
        myworkout,
        fbworkout,
        videodisplaymodal,
        videolibrary,
        genericvideodisplaymodal,
        genericpagedisplaymodal,
        ForumHome,
        showofforumdash,
        showofforumcommunity,
        showofforumcreate,
showofforumcreatem,
        svgtest,
        tsdetailmodal,
        tsvisibilityswitchermodal,
        tscameracapture,
        tsphotopreview,
        tstimersettings,
        lettersdash,
        lettersdashp,
        futureselfletter,
        prizes,
        testcanvas,
        svgbase,
        sitedash,
        coursemanage,
        lessonsmanage,
        editlesson,
        lessoncatmanage,
        edudash,
        learningcentral,
        lessonmodal,
        assetmgmt,
        // genericmodal,
        newstarterchecklist,
        morningeveningfocus,
        celebration,
        leaderboard,


    }
});
